export default __webpack_public_path__ + "3b72eaf6780573b8cbdb12212d661a18.png";